/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  dashboard,
  documenticon,
  encounter,
  logout,
  menuicon04,
  profileicon,
} from "../components/imagepath";
import Scrollbars from "react-custom-scrollbars-2";

const Sidebar = (props) => {
  const [sidebar, setSidebar] = useState("");
  const handleClick = (e, item, item1, item3) => {
    const div = document.querySelector(`#${item}`);
    const ulDiv = document.querySelector(`.${item1}`);
    e?.target?.className
      ? (ulDiv.style.display = "none")
      : (ulDiv.style.display = "block");
    e?.target?.className
      ? div.classList.remove("subdrop")
      : div.classList.add("subdrop");
  };

  useEffect(() => {
    if (props?.id && props?.id1) {
      const ele = document.getElementById(`${props?.id}`);
      handleClick(ele, props?.id, props?.id1);
    }
  }, []);

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div
              id="sidebar-menu"
              className="sidebar-menu"
              onMouseLeave={expandMenu}
              onMouseOver={expandMenuOpen}
            >
              <ul>
                <li className="menu-title">Main</li>
                <li>
                  <Link
                    className={
                      props?.activeClassName === "card-patientdashboard"
                        ? "active"
                        : ""
                    }
                    id="menu-item"
                    to="/doctordashboard"
                  >
                    <span className="menu-side">
                      <img src={dashboard} alt="" />
                    </span>{" "}
                    <span>Dashboard</span>
                  </Link>
                </li>

                <li>
                  <Link to="/guideline">
                    <span className="menu-side">
                      <img src={profileicon} alt="" />
                    </span>{" "}
                    <span>Guidelines Instructions</span>
                  </Link>
                </li>
                <li>
                  <Link to="/chronic">
                    <span className="menu-side">
                      <img src={menuicon04} alt="" />
                    </span>{" "}
                    <span>Chronic Management</span>
                  </Link>
                </li>
                <li>
                  <Link to="/annual">
                    <span className="menu-side">
                      <img
                        color="rgba(51, 53, 72, 0.75)"
                        src={encounter}
                        alt=""
                      />
                    </span>{" "}
                    <span>Annual Management</span>
                  </Link>
                </li>

                <li>
                  <Link to="/doctordashboard">
                    <span className="menu-side">
                      <img src={documenticon} alt="" />
                    </span>{" "}
                    <span> ABHA Panel</span>
                  </Link>
                </li>

                {/* <li>
                  <Link to="/settings">
                    <span className="menu-side">
                      <img src={menuicon16} alt="" />
                    </span>{" "}
                    <span>Settings</span>
                  </Link>
                </li> */}
                <li className="">
                  <Link to="/login">
                    <span className="menu-side">
                      <img src={logout} alt="" />
                    </span>{" "}
                    <span>Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};
export default Sidebar;
